import React, { useEffect } from 'react';

const SitemapGenerator = () => {
  useEffect(() => {
    // This component is for dynamic sitemap generation at runtime
    // The static sitemap.xml file in public/ will be used for production
    
    // We could generate a dynamic sitemap here if needed
    console.log('Sitemap available at /sitemap.xml');
  }, []);

  return null; // This component doesn't render anything visible
};

export default SitemapGenerator;